module.exports = __webpack_public_path__ + "static/icon-short-716f6c147e79c9fe3a9a78016f255706.png";